import { addClass, removeClass, createDom } from 'xgplayer/src/utils/util'
import '../style/controls/error.scss'
import iconNotFound from '@/components/resources/dialog/Video/assets/not-found.svg'

let s_error = function() {
  let player = this
  let root = player.root

  let error = createDom(
    'xg-error',
    '<span class="xgplayer-error-text">请<span class="xgplayer-error-refresh">刷新</span>试试</span>',
    {},
    'xgplayer-error'
  )
  player.once('ready', () => {
    root.appendChild(error)
  })

  let text = error.querySelector('.xgplayer-error-text')
  let refresh = null

  function onError(e) {
    // player.controls.style.display = 'none'
    // if (player.error) {
    //   text.innerHTML = player.error
    // } else {

    if (e && e.message) {
      const _target = e.status.find((item) => item.value === e.message)
      text.innerHTML = `<div class="state"><img class="icon" src="${iconNotFound}" alt="" /><p class="description">${_target?.label ?? '未知错误'}</p></div>`
    }else if (player.config.lang && player.config.lang === 'zh-cn') {
      text.innerHTML = player.config.errorTips || `请<span class="xgplayer-error-refresh">刷新</span>试试`
    } else {
      text.innerHTML = player.config.errorTips || `please try to <span class="xgplayer-error-refresh">refresh</span>`
    }
    // }
    addClass(player.root, 'xgplayer-is-error')
    refresh = error.querySelector('.xgplayer-error-refresh')
    if (refresh) {
      ;['touchend', 'click'].forEach(item => {
        refresh.addEventListener(item, function(e) {
          e.preventDefault()
          e.stopPropagation()
          player.autoplay = true
          player.once('playing', () => {
            removeClass(player.root, 'xgplayer-is-error')
          })
          player.src = player.config.url
        })
      })
    }
  }
  player.on('error', onError)
  function onDestroy() {
    player.off('error', onError)
    player.off('destroy', onDestroy)
  }
  player.once('destroy', onDestroy)
}

export default {
  name: 's_error',
  method: s_error
}
